import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CentresOfExcellence.css';
import grpimg from '../assets/images/Website (2).png';
import pediatricImg from '../assets/images/Pediatric-Practice-Management-Solution-01.webp';
import generalPhysicianImg from '../assets/images/general-physician-doctors-general-physician-doctors-1-q6wja.avif';
import gynecologyImg from '../assets/images/GYNAECOLOGY.png';
import scansTestsImg from '../assets/images/Doctors_MS_GettyImages1300036844_Header-1024x575.webp';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

function CentresOfExcellence() {
  const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentServiceIndex((prevIndex) => (prevIndex + 1) % services.length);
        setIsFading(false);
      }, 500); // Half second for fade out, then change content
    }, 4000); // 4 seconds

    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      title: "Pediatric Care",
      description: "Our pediatric department provides comprehensive healthcare for infants, children, and adolescents. From routine check-ups to specialized treatments, our experienced pediatricians ensure the healthy development and well-being of your little ones with compassionate care.",
      speciality: "CHILD HEALTHCARE",
      image: pediatricImg,
      category: "PEDIATRIC"
    },
    {
      title: "General Physicians",
      description: "Our general physicians offer primary healthcare services for all ages. They provide preventive care, diagnose and treat common illnesses, manage chronic conditions, and serve as your first point of contact for overall health maintenance and wellness.",
      speciality: "PRIMARY CARE",
      image: generalPhysicianImg,
      category: "GENERAL PHYSICIANS"
    },
    {
      title: "Gynecology Services",
      description: "Comprehensive women's health services including routine gynecological exams, prenatal care, family planning, menopause management, and advanced treatments for gynecological conditions. Our specialists provide personalized care for every stage of a woman's life.",
      speciality: "WOMEN'S HEALTH",
      image: gynecologyImg,
      category: "GYNECOLOGY"
    },
    {
      title: "Scans & Tests",
      description: "State-of-the-art diagnostic services including 3D and 4D ultrasound scans, MRI, CT scans, X-rays, blood tests, and specialized screenings. Our advanced imaging technology ensures accurate diagnosis with the latest equipment and expert interpretation.",
      speciality: "ADVANCED DIAGNOSTICS",
      image: scansTestsImg,
      category: "SCANS & TESTS"
    }
  ];

  const nextService = () => {
    setCurrentServiceIndex((prevIndex) => (prevIndex + 1) % services.length);
  };

  const prevService = () => {
    setCurrentServiceIndex((prevIndex) => (prevIndex - 1 + services.length) % services.length);
  };

  const goToService = (index) => {
    setCurrentServiceIndex(index);
  };

  const currentService = services[currentServiceIndex];

  return (
    <section className="centres-section">
      <div className="container">
        <h2 className="mb-3"> Our Specialities</h2>
        <p className="centres-intro">Experience comprehensive healthcare services at JDS Hospital. Our specialized departments deliver expert care across pediatrics, general medicine, gynecology, and advanced diagnostic services. Each service is designed to provide exceptional healthcare with cutting-edge technology and compassionate professionals.</p>

        <div className="category-pills">
          {services.map((service, index) => (
            <button
              key={index}
              className={`category-pill ${index === currentServiceIndex ? 'active' : ''}`}
              onClick={() => goToService(index)}
            >
              {service.category}
            </button>
          ))}
        </div>

        <div className="mt-4">
          <div className={`centre-card ${isFading ? 'fade' : ''}`}>
            <div className="carousel-arrow left" onClick={prevService}><FaChevronLeft /></div>
            <div className="carousel-arrow right" onClick={nextService}><FaChevronRight /></div>

            <div className="centre-text">
              <h3>{currentService.title}</h3>
              <p>{currentService.description}</p>

              <div className="top-specialities">
                <h6>Top Specialities & Procedures</h6>
                <div className="speciality-tag">{currentService.speciality}</div>
              </div>

              <div className="cta-row">
                <button className="btn-outline-teal">FIND DOCTOR</button>
                <Link to={`/services/${currentService.category.toLowerCase().replace(' ', '-')}`} className="btn-solid-teal-link">
                  <button className="btn-solid-teal">EXPLORE MORE</button>
                </Link>
              </div>
            </div>

            <div className="centre-image">
              <img src={currentService.image} alt={`${currentService.title} Illustration`} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CentresOfExcellence;
